import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogs';

const BlogPage: React.FC = () => {
  return (
    <>
      <div className="bg-gradient-to-r from-primary-800 to-primary-700 text-white py-20 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-accent-500 opacity-20 rounded-full blur-2xl"></div>
        <div className="container mx-auto px-4 relative">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Blog</h1>
          <p className="text-xl max-w-3xl">
            Insights, updates, and ideas on AI-powered business from the AiDA team.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        {blogPosts.length === 0 ? (
          <div className="max-w-2xl mx-auto text-center py-16">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">No posts yet</h2>
            <p className="text-lg text-gray-600">
              We're working on our first articles. Check back soon for the latest from AiDA.
            </p>
          </div>
        ) : (
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {blogPosts.map((post) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                className="block bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow p-6"
              >
                <p className="text-sm text-gray-500 mb-2">{post.date}</p>
                <h2 className="text-xl font-semibold text-gray-800 mb-3">{post.title}</h2>
                <p className="text-gray-600 mb-4">{post.excerpt}</p>
                <span className="text-accent-600 font-medium">Read more &rarr;</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default BlogPage;
